import { useEffect, useState } from "react";
import { url } from "../App";

const useMenu = () => {
    const [menuItems, setMenuItems] = useState([]);
    const [categoryItems, setCategoryItems] = useState([]);
    useEffect(() => {
        // GET request using fetch inside useEffect React hook
        fetch(`${url}/category/`)
            .then(response => response.json())
            .then(jsonData => {
                // console.log(jsonData);
                setCategoryItems(jsonData);
            });

        // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);
    useEffect(() => {
        // GET request using fetch inside useEffect React hook
        fetch(`${url}/menu/`)
            .then(response => response.json())
            .then(jsonData => {
                // console.log(jsonData);
                setMenuItems(jsonData);
            });

        // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);
    return {
        categoryItems,
        menuItems,
    };
};

export default useMenu;